"use client";

import { useEffect } from "react";
import { DIAGNOSIS_UNLOCK_SIMPLE_LOADING_MS } from "./diagnosisUnlockFourStep.contract";

/**
 * 无四步 progress 时的假 Loading — 固定时长后 `onComplete`。
 * 与步骤 progress hook 互斥：`showStepProgress: false` 时启用。
 */
export function useDiagnosisUnlockSimpleLoading(options: {
  enabled: boolean;
  paused?: boolean;
  durationMs?: number;
  onComplete: () => void;
}): void {
  const { enabled, paused = false, durationMs, onComplete } = options;

  useEffect(() => {
    if (!enabled || paused) {
      return;
    }

    const timer = window.setTimeout(() => {
      onComplete();
    }, durationMs ?? DIAGNOSIS_UNLOCK_SIMPLE_LOADING_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, [durationMs, enabled, onComplete, paused]);
}
